module.exports = __webpack_public_path__ + "img/png-9.4d612caa.png";